import { render } from "./verification-methods.vue?vue&type=template&id=6949054e&scoped=true"
import script from "./verification-methods.vue?vue&type=script&lang=js"
export * from "./verification-methods.vue?vue&type=script&lang=js"

import "./verification-methods.vue?vue&type=style&index=0&id=6949054e&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6949054e"]])

export default __exports__